import { DetailList } from 'components/site/modals/DetailListModal/DetailList';
import { ModalWrapperMini } from 'components/site/modals/ModalWrapperMini';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';

interface Props {
    storyIds: string[];
}

export const DetailListModalMini = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);

    const onClose = () => {
        ctxModal.setDetailListModal(null);
    };

    return (
        <ModalWrapperMini onClose={onClose} content={<DetailList storyIds={props.storyIds} />} />
    );
};
